import React from 'react';
import type { Inquiry } from '@/services/types';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface CellActionProps {
  data: Inquiry;
}

export const CellAction: React.FC<CellActionProps> = ({ data }) => {
  const navigate = useNavigate();

  const handleReply = () => {
    navigate(`/dashboard/inquiries/${data.id}/reply`);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Button
        variant='outline'
        size='sm'
        onClick={handleReply}
        className='flex items-center gap-2'
      >
        <MessageSquare className='h-4 w-4' />
        {data.status === 'resolved' ? 'View' : 'Reply'}
      </Button>
    </div>
  );
};